import { DateUtil } from '@/utils';
import mutations from './samplePageMutation';
import actions from './samplePageAction';
import getters from './samplePageGetter';

const state = {
  message: '버튼 클릭',
  cnt: 0,
  gridData: {},
  searchParam: {
    searchType: '',
    searchCondition: 'cn',
    searchKeyword: null,
    searchPeriod: {
      startDate: null,
      endDate: null,
    },
  },
  tempInfo: {},
  adUserInfoList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/sample/samplePage/samplePageStore.js